document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener("click", function(e) {
        // Check if the clicked element or its parent is the checkout button
        const checkoutBtn = e.target.closest(".button-checkout");
        if (checkoutBtn) {
            e.preventDefault();
            alert("International Payment: For Non-Resident Indian (NRI) customers wishing to make payments using international credit or debit cards, please select the PayPal option at checkout.");
        }
    });
});
